import { render, staticRenderFns } from "./modalValidacaoValorReferencia.vue?vue&type=template&id=32981825&"
import script from "./modalValidacaoValorReferencia.vue?vue&type=script&lang=js&"
export * from "./modalValidacaoValorReferencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports